module.exports = __webpack_public_path__ + "static/media/RO Plant.85601075.png";